<template>
    <!--@formatter:off-->
    <!-- [D] 유형: 만족도 선택시에 .satisfied 추가 -->
    <li class="ex" v-bind:class="{satisfied: isTable}">
        <div class="info_lbl">
            <template v-if="isTable">
                {{$t('SurveyQuestionAnswerEditor_subQuestionNumber', {number: questionNumber, subNumber: answerNumber})}}
            </template>
            <template v-else>
                {{$t('SurveyQuestionAnswerEditor_exampleNumber', {number: answerNumber})}}
            </template>
        </div>
        <div class="info_txt">
            <div class="bx_input_wrap">
                <TextArea
                        ref="input"
                        :id="inputId"
                        :placeholder="isTable ? $t('SurveyQuestionAnswerEditor_inputSatisfyQuestion') : $t('SurveyQuestionAnswerEditor_inputExample')"
                        :maxlength="300"
                        v-model="text"
                        cols="50"
                        rows="1"
                        label-class="input_lbl"
                        label-tag="label"
                        :resize="true"
                        :one-line="true"
                        @keydown.shift.up="moveUpAnswer"
                        @keydown.shift.down="moveDownAnswer"
                        @keydown.enter="addOrFocusNextAnswer"
                />
                <ul class="b_area">
                    <li v-if="isShowImage" v-show="!isTable">
                        <ImageUpload v-slot="{openFileDialog}" v-on:requestUpload="uploadImage"
                                     v-ga-helper:click="gaImageUpload"
                        >
                            <button type="button" class="btn" @click.prevent="openFileDialog">{{$t('SurveyQuestionAnswerEditor_attachImage')}}</button>
                        </ImageUpload>
                    </li>
                    <li v-if="isShowSubQuestion && !isSub" v-show="!isTable && !isParentFCFS">
                      <button
                          type="button"
                          class="btn"
                          @click.prevent="addSubQuestion"
                          v-ga-helper:click="{
                              view_category: '설문리스트',
                              view_area: '하위질문클릭',
                              view_label: '',
                          }"
                      >
                        {{$t('SurveyQuestionAnswerEditor_subQuestion')}}
                      </button>
                    </li>
                    <li v-show="showDelete">
                      <button
                          type="button"
                          class="btn btn_del"
                          v-on:click.prevent="deleteAnswer"
                          v-ga-helper:click="{
                              view_category: '설문리스트',
                              view_area: '보기삭제클릭',
                              view_label: '',
                          }"
                      >
                        {{$t('SurveyQuestionAnswerEditor_delete')}}
                      </button>
                    </li>
                    <li v-show="enableMoveDownAnswer"><button type="button" class="btn btn_move btn_down" @click.prevent="onClickMoveDownAnswer"><span class="blind">⬇</span></button></li>
                    <li v-show="enableMoveUpAnswer"><button type="button" class="btn btn_move btn_up" @click.prevent="onClickMoveUpAnswer"><span class="blind">⬆</span></button></li>
                </ul>
            </div>
        </div>
        <div class="bx_include_file" v-if="showImage">
            <div class="image">
                <img :src="image.url" alt="" style="max-width: 100%">
                <button type="button" class="btn_delete" @click.prevent="deleteImage"><span class="sp">{{$t('SurveyQuestionAnswerEditor_deleteImage')}}</span></button>
            </div>
        </div>
    </li>
    <!--@formatter:on-->
</template>

<script>
import {
    ADD_SUB_QUESTION,
    DELETE_ANSWER,
    DELETE_ANSWER_IMAGE,
    DELETE_QUESTION,
    MAX_SUB_QUESTION,
    MOVE_DOWN_ANSWER,
    MOVE_UP_ANSWER,
    NAMESPACE,
    SET_ANSWER_TEXT,
    UPLOAD_ANSWER_IMAGE,
} from '@/common/store/modules/survey/editor.js';
import TextArea from '@/iamteacherpc/components/common/TextArea.vue';
import {createNamespacedHelpers} from 'vuex';
import {requestAlert, requestConfirm} from '@/iamteacherpc/utils/iframe.js';
import {REQUEST_STATE} from '@/iamteacherpc/consts/request.js';
import ImageUpload from '@/iamteacherpc/components/common/ImageUpload.vue';
import {SET_QUESTION_QUESTION} from '@/common/store/modules/common/editor/question.js';
import {
    LIST_CHANGE,
    MOVE_DOWN_SUB_QUESTION,
    MOVE_UP_SUB_QUESTION,
    STOP_LIST_CHANGE,
} from '@/common/store/modules/common/editor/questionList.js';
import ACCEPTED_DOMAIN from "@common/consts/accepted-domain";

const {mapActions} = createNamespacedHelpers(NAMESPACE);

export default {
    name: 'SurveyQuestionAnswerEditor',
    components: {ImageUpload, TextArea},
    props: {
        answer: {
            type: Object,
            required: true,
            },
            question: {
                type: Object,
                required: true,
            },
            questionIndex: {
                type: Number,
                required: true
            },
            answerIndex: {
                type: Number,
                required: true
            },
            isTable: {
                type: Boolean,
                default: false,
            },
            siblingsCount: {
                type: Number,
                required: true,
            },
        isSub: {
            type: Boolean,
            required: true,
        },
        isParentFCFS: {
            type: Boolean,
            default: false,
        },
        isShowImage: {
            type: Boolean,
            default: true,
        },
        isShowSubQuestion: {
            type: Boolean,
            default: true,
        },
    },

    computed: {
            text: {
                get() {
                    if (this.isTable) {
                        return this.question.question;
                    } else {
                        return this.answer.text;
                    }
                },
                set(newValue) {
                    if (this.isTable) {
                        this.storeSetQuestion({question: this.question, text: newValue});
                    } else {
                        this.storeSetText({answer: this.answer, text: newValue});
                    }
                }
            },

            image() {
                return this.answer.image;
            },

            questionNumber() {
                return '' + (this.questionIndex + 1);
            },

            answerNumber() {
                return '' + (this.answerIndex + 1);
            },

            showDelete() {
                return this.siblingsCount > 1;
            },

            enableMoveDownAnswer() {
                return (this.answerIndex + 1) !== this.siblingsCount;
            },

            enableMoveUpAnswer() {
                return this.answerIndex !== 0;
            },

            showImage() {
                return this.image && this.image.uploadState === REQUEST_STATE.SUCCESS;
            },

            inputId() {
                if (this.isTable) {
                    return `q${this.question.questionNo}`;
                } else {
                    return `a${this.answer.answerNo}`;
                }
            }
        },

    methods: {
            ...mapActions({
                storeSetText: SET_ANSWER_TEXT,
                storeSetQuestion: SET_QUESTION_QUESTION,
                storeUploadImage: UPLOAD_ANSWER_IMAGE,
                storeDeleteImage: DELETE_ANSWER_IMAGE,
                storeDeleteAnswer: DELETE_ANSWER,
                storeMoveDownAnswer: MOVE_DOWN_ANSWER,
                storeMoveUpAnswer: MOVE_UP_ANSWER,
                storeDeleteQuestion: DELETE_QUESTION,
                storeAddSubQuestion: ADD_SUB_QUESTION,
                stopListChange: STOP_LIST_CHANGE,
                listChange: LIST_CHANGE,
                storeMoveUpSubQuestion: MOVE_UP_SUB_QUESTION,
                storeMoveDownSubQuestion: MOVE_DOWN_SUB_QUESTION,
            }),

            gaImageUpload() {
                // surveyEditor
                return {
                    view_category: '설문리스트',
                    view_area: '보기이미지첨부클릭',
                    view_label: '',
                }
            },

            uploadImage(file) {
                this.storeUploadImage({
                    answer: this.answer,
                    file: file
                }).catch(e => {
                    requestAlert({title: e.message, okText: this.$t('common_confirm')});
                });
            },

            deleteImage() {
                this.storeDeleteImage({answer: this.answer})
            },

            deleteAnswer() {
                if (this.isTable) {
                    this.stopListChange();

                    requestConfirm({
                        title: this.$t('SurveyQuestionAnswerEditor_confirmDeleteQuestion'),
                        okText: this.$t('common_confirm'),
                        cancelText: this.$t('common_cancel')
                    }).then(() => {
                        this.storeDeleteQuestion({question: this.question});
                    }).catch(() => {
                        // do nothing
                    }).finally(() => {
                        this.listChange();
                    });
                } else {
                    this.storeDeleteAnswer({answer: this.answer});
                }
            },

            addSubQuestion() {
                if (this.question.questions.length >= MAX_SUB_QUESTION) {
                    this.stopListChange();

                    requestAlert({
                        title: this.$t('SurveyQuestionAnswerEditor_maxSubQuestionDesc', {max: MAX_SUB_QUESTION}),
                        okText: this.$t('common_confirm')
                    }).then(() => this.listChange());

                    return;
                }

                this.storeAddSubQuestion({question: this.question, answerNo: this.answer.answerNo});
            },

            focusAnswer() {
                this.$refs.input.focus();
            },

            addOrFocusNextAnswer(event) {
                if (event.isComposing) {
                    return;
                }

                if (this.enableMoveDownAnswer) {
                    this.$emit('focusNextAnswer');
                    return;
                }
                this.$emit('addAnswerOrTableQuestion');
            },

            onClickMoveDownAnswer(event){
                this.moveDownAnswer(event);
                this.showAnswerOrderSpotGuide();
            },
            onClickMoveUpAnswer(event){
                this.moveUpAnswer(event);
                this.showAnswerOrderSpotGuide();
            },

            moveDownAnswer(event) {
                if (event.isComposing) {
                    return;
                }

                if (this.isTable) {
                    const {parentQuestion, questionNo: subQuestionNo} = this.question;
                    this.storeMoveDownSubQuestion({parentQuestionNo: parentQuestion.questionNo, subQuestionNo});
                } else {
                    this.storeMoveDownAnswer({answer: this.answer});
                }
                this.$emit('focusNextAnswer');
            },

            moveUpAnswer(event) {
                if (event.isComposing) {
                    return;
                }

                if (this.isTable) {
                    const {parentQuestion, questionNo: subQuestionNo} = this.question;
                    this.storeMoveUpSubQuestion({parentQuestionNo: parentQuestion.questionNo, subQuestionNo});
                } else {
                    this.storeMoveUpAnswer({answer: this.answer});
                }
                this.$emit('focusPreviousAnswer');
            },

            showAnswerOrderSpotGuide(){
                // postMessage 먼저 보낼 때
                ACCEPTED_DOMAIN[process.env.VUE_APP_TARGET_ORIGIN].forEach(origin => {
                    window.parent.postMessage(
                        {
                          type: 'OPEN_SPOTGUIDE',
                          data: {
                            areaId: 'SURVEY_ANSWER_ORDER',
                          },
                        },
                        origin,
                    )
                })
            },
        }
}
</script>

<style scoped>

</style>
